import {ReviewListPageContent} from './review-list-page-content/review-list-page-content';
import {ReviewsStateProvider} from './reviews-state/reviews-state-provider';

export function Reviews(): JSX.Element {
    return (
        <ReviewsStateProvider>
            <ReviewListPageContent />
        </ReviewsStateProvider>
    );
}
